import { useCurrentUser } from '@qualio/ui-components';

export const useFormatDate = () => {
  const { formatDate } = useCurrentUser();
  const formatDateWrapper = (
    utcDate: Date | string,
    includeTime?: boolean,
  ): string => {
    try {
      const formattedDate = formatDate(utcDate, includeTime);

      return formattedDate;
    } catch (e: unknown) {
      console.log(e);
      return '';
    }
  };

  return formatDateWrapper;
};
